import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Audience } from 'src/app/models/services/audience';
import { Tag } from 'src/app/models/services/tag';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';
import { Observable, of } from 'rxjs'
import { DialogService } from 'src/app/services/core/dialog.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export function existingTagValidator(tags: Tag[]): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors> | null => {
    let err: ValidationErrors = null;
    if (tags.findIndex(x => x.name == control.value) >= 0)
      err = { existingTag: { value: control.value } };

    return of(err);
  };
}

@Component({
  selector: 'audience-tags-block',
  templateUrl: './audience-tags-block.component.html',
  styleUrls: ['./audience-tags-block.component.sass']
})
export class AudienceTagsBlockComponent implements OnInit {
  @Input()
  public audience: Audience;

  public newTagFormControl: FormControl = new FormControl(); // It will be redefined later
  
  allTags: Tag[];
  selectedTags: Tag[];
  nonSelectedTags: Tag[];
  matcher: MyErrorStateMatcher = new ErrorStateMatcher();

  constructor(
    private audiencesService: AudiencesService,
    private dialogService: DialogService,
    private spinnerService: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinnerService.show('dialogSpinner');
    this.audiencesService.getAllTags().subscribe((response: Tag[]) => {
      this.allTags = response;
      this.selectedTags = [...this.audience.tags];
      this.nonSelectedTags = response.filter(x => this.selectedTags.findIndex(y => y.id == x.id) == -1);
      this.newTagFormControl  = new FormControl('', Validators.required, existingTagValidator(this.allTags));
      this.spinnerService.hide('dialogSpinner');
    }, () =>  {
      this.spinnerService.hide('dialogSpinner');
    })
  }

  onAccept = (): void  => {   
    this.spinnerService.show();     
    this.audiencesService.updateTags(this.audience.id, this.selectedTags).subscribe(
        () => { 
          this.spinnerService.hide();
          this.dialogService.showMessage("Audience tags", "Tags created / updated successfully");
          //_this.startRefreshPolling();
        },
        () => { 
          this.spinnerService.hide();
          //_this.startRefreshPolling(); 
        }
    );
  }

  acceptButtonEnabled = (): boolean => {
    return true;
  }

  removeTag = (tag: Tag): void => {
    this.nonSelectedTags.push(tag);
    this.selectedTags.splice(this.selectedTags.findIndex(x => x.name == tag.name), 1); // Maybe it's a new one which has no id
  }

  addTag = (tag: Tag): void => {
    this.selectedTags.push(tag);
    this.nonSelectedTags.splice(this.nonSelectedTags.findIndex(x => x.id == tag.id), 1);
  }

  addNewTag = (): void => {
    this.selectedTags.push({
      name: this.newTagFormControl.value
    });
    this.newTagFormControl.reset();
  }  
}